import { ZERO_FIAT_AMOUNT } from "@hsbc/shared";

export const getInitialWalletPaymentContext = () => ({
  creditPaymentAmount: ZERO_FIAT_AMOUNT,
  creditBalance: ZERO_FIAT_AMOUNT,
});
